import { useState, useEffect } from 'react';
import { Switch } from "../../../components/ui/switch";
import { Button } from '@/components/ui/button';

interface RememberMePromptProps {
  onSubmit: (rememberMe: boolean) => void;
  isLoading: boolean;
  showTitle?: boolean;
  token?: string;
}

export function RememberMePrompt({ onSubmit, isLoading, showTitle = true, token }: RememberMePromptProps) {
  const [rememberMe, setRememberMe] = useState(false);

  // Get first octet of token (part before first period or dash)
  const maskedToken = token ? `${token.substring(0, 10)}...` : null;

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter' && !isLoading) {
        onSubmit(rememberMe);
      }
    };

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [onSubmit, isLoading, rememberMe]);

  return (
    <div className="space-y-4 sm:space-y-6">
      {showTitle && (
        <div className="text-center">
          <h1 className="heading-mobile">Sign in to Promo</h1>
          <p className="mt-2 text-gray-600">Your magic link is ready to verify</p>
        </div>
      )}
      
      {maskedToken && (
        <div className="space-y-2">
          <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-md font-mono text-sm text-gray-600 text-center">
            {maskedToken}
          </div>
        </div>
      )}
      
      <div className="flex items-center justify-between px-1">
        <label 
          htmlFor="remember-me" 
          className="text-sm text-gray-600"
        >
          Remember me for 30 days
        </label>
        <Switch
          id="remember-me"
          checked={rememberMe}
          onCheckedChange={setRememberMe}
          aria-label="Remember me for 30 days"
        />
      </div>

      <Button
        onClick={() => onSubmit(rememberMe)}
        disabled={isLoading}
        className="block mx-auto w-full"
      >
        {isLoading ? 'Signing in...' : 'Sign in'}
      </Button>
    </div>
  );
} 